"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandednotification = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 46",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandednotification` : '') + (description ? ` desc-brandednotification` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandednotification"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandednotification"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M44.72 5.1A33.06 33.06 0 0 0 28.5 1C13.3 1 1 10.52 1 22.2 1 27.97 3.99 33.18 8.82 37a102.63 102.63 0 0 0 35.9-31.9Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.64 42.49c.08.03.16.07.24.07l14.94 3.41c.96.21 1.74-.78 1.34-1.7l-3.4-7.69.03-.07C53.12 32.87 56 27.84 56 22.2c0-7.03-4.44-13.25-11.27-17.12A102.55 102.55 0 0 1 8.83 37c4.99 3.95 11.96 6.4 19.67 6.4.95 0 3.83-.29 7.15-.9h-.01Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.42 26a2.99 2.99 0 0 0 2.97-3c0-1.65-1.33-3-2.96-3a2.98 2.98 0 0 0-2.96 3c0 1.66 1.33 3 2.96 3Z",
    fill: "#FFF5EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.11 26a2.99 2.99 0 0 0 2.97-3c0-1.65-1.33-3-2.96-3a2.98 2.98 0 0 0-2.96 3c0 1.66 1.32 3 2.96 3Z",
    fill: "#FFF5EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.73 26a2.99 2.99 0 0 0 2.97-3c0-1.65-1.33-3-2.96-3a2.98 2.98 0 0 0-2.96 3c0 1.66 1.33 3 2.96 3Z",
    fill: "#FFF5EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.43 2.28A5.73 5.73 0 0 0 5.38.59 5.81 5.81 0 0 0 1.1 3.83l-.1.21v.01a6.11 6.11 0 0 0 1.02 6.46v.01l7.97 8.6a1.19 1.19 0 0 0 1.75 0l7.8-8.44a6.1 6.1 0 0 0 1.08-6.86l-.01-.01-.12-.22a5.71 5.71 0 0 0-9.2-1.32l-.15.14v.01l-.28.3-.43-.44Z",
    fill: "#E90B5A",
    stroke: "white"
  }));
};
var _default = exports.default = brandednotification;